<template>
  <section class="features-section">
    <v-container
      id="feature-section"
      v-hash-intersect
      class="d-flex align-end justify-space-between"
    >
      <div class="pb-2 pb-sm-4">
        <h2 class="text-h5 text-sm-h3 mb-6 mb-sm-8">
          МедТочка — инструмент для <br class="d-none d-sm-block" />пациентов, врачей и клиник
        </h2>
        <ChipsBar
          :value="$route.name"
          :items="chipsItems"
          @click:item="handleClickChipItem"
        />
      </div>
      <v-img
        max-height="254"
        height="100%"
        class="d-none d-md-flex"
        v-bind="targetImgProps"
      />
    </v-container>

    <v-divider />

    <NuxtPage class="features-section__content" />
  </section>
</template>

<script setup lang="ts">
import { FEATURE_ROUTE_NAME } from '~/enums/features'

const locale = useAppLocale()

const chipsItems = [
  { type: FEATURE_ROUTE_NAME.PATIENT, name: 'Пациентам' },
  { type: FEATURE_ROUTE_NAME.DOCTOR, name: 'Врачам' },
  ...(locale.isRu
    ? [{ type: FEATURE_ROUTE_NAME.CLINIC, name: 'Клиникам' }]
    : []
  ),
]

const $route = useRoute()

const targetImgProps = computed(() => {
  let src = ''

  switch ($route.name) {
    case FEATURE_ROUTE_NAME.PATIENT:
      src = '/graphics/character-patient.svg'
      break
    case FEATURE_ROUTE_NAME.DOCTOR:
      src = '/graphics/character-doctor.svg'
      break
    case FEATURE_ROUTE_NAME.CLINIC:
      src = '/graphics/character-clinic.svg'
      break
  }

  return $route.name === FEATURE_ROUTE_NAME.CLINIC
    ? {
      src,
      maxWidth: 374,
      aspectRatio: 0.676470588235,
    }
    : {
      src,
      maxWidth: 296,
      aspectRatio: 0.85472972973,
    }
})

function handleClickChipItem(item: string) {
  navigateTo({ name: item, hash: '#feature-section' })
}
</script>
